<template>
  <v-btn
    outlined
    small
    :color="color"
    :disabled="dataSelectorKey && !!selectModel(modelValue, dataSelectorKey)"
    @click="onClick(modelValue)"
    class="text-capitalize"
    :style="buttonStyle"
  >
    <v-icon v-if="icon" dense small class="mr-1">{{ icon }}</v-icon>
    <span v-if="dataSelectorKey && selectModel(modelValue, dataSelectorKey)">
      {{ selectModel(modelValue, dataSelectorKey) }}
    </span>
    <span v-else-if="dataSelectorKey && !selectModel(modelValue, dataSelectorKey)">
      Generate Code
    </span>
  </v-btn>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ModelVue from "../../ModelVue";

@Component({
  components: {},
})
export default class FColumnBtn extends ModelVue {
  @Prop()
  onClick: (item: any) => void;

  @Prop({
    default: "green",
  })
  color: string;

  @Prop()
  icon: string;

  @Prop()
  dataSelectorKey: string;

  get hasGeneratedCode() {
    return this.dataSelectorKey && !!this.selectModel(this.modelValue, this.dataSelectorKey);
  }

  get buttonStyle() {
    const baseStyle = "min-width: auto;";
    if (this.hasGeneratedCode) {
      return `${baseStyle} color: red !important; border-color: red !important;`;
    }
    return baseStyle;
  }
}
</script>
